/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

@supports (position-anchor: --selected) {
  nve-button-group {
    /* prettier-ignore */
    &:has(> :state(pressed)):not(:has(> :state(pressed) ~ :state(pressed)), :has(> [container]), :has(> [interaction])) {
      --indicator-background: var(--nve-sys-support-accent-color);
      --indicator-border-radius: var(--nve-ref-border-radius-sm);

      &::after {
        background: var(--indicator-background);
        border-radius: var(--indicator-border-radius);
        position: fixed;
        display: block;
        content: '';
        width: anchor-size(width);
        height: anchor-size(height);
        transition:
          left var(--nve-ref-animation-duration-150) var(--nve-ref-animation-easing-100),
          top var(--nve-ref-animation-duration-150) var(--nve-ref-animation-easing-100);
        position-anchor: --selected;
        top: anchor(top);
        left: anchor(left);
        z-index: 0;
      }

      &[orientation='vertical']::after {
        transition:
          top var(--nve-ref-animation-duration-150) var(--nve-ref-animation-easing-100),
          left var(--nve-ref-animation-duration-150) var(--nve-ref-animation-easing-100);
      }

      &[container='rounded']::after {
        --indicator-border-radius: var(--nve-ref-border-radius-full);
      }

      > nve-button,
      > nve-icon-button {
        &:state(pressed) {
          --background: transparent;
          anchor-name: --selected;
          z-index: 1;
        }
      }
    }
  }
}
